"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = require("../Tooltip");

var _index = _interopRequireDefault(require("./index.styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Filter = function Filter(_ref) {
  var label = _ref.label,
      groupNum = _ref.groupNum,
      filterFunction = _ref.filterFunction,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters;
  return /*#__PURE__*/_react.default.createElement(_index.default.Filter, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "filter-label"
  }, label), filters.map(function (eachFilter, index) {
    var _eachFilter$toolTip, _eachFilter$toolTip2;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "filter-line",
      key: eachFilter.label
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "input-box",
      id: "label-".concat(groupNum, "-").concat(index),
      type: "checkbox",
      onClick: function onClick() {
        return filterFunction(eachFilter.label);
      }
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "label-".concat(groupNum, "-").concat(index),
      className: "input-label"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        marginRight: '12px'
      }
    }, eachFilter.label), eachFilter.toolTip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      title: (_eachFilter$toolTip = eachFilter.toolTip) === null || _eachFilter$toolTip === void 0 ? void 0 : _eachFilter$toolTip.title,
      paragraph: (_eachFilter$toolTip2 = eachFilter.toolTip) === null || _eachFilter$toolTip2 === void 0 ? void 0 : _eachFilter$toolTip2.paragraph
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "filter-number"
    }, eachFilter.number));
  }));
};

exports.Filter = Filter;